import styled from 'styled-components';

export const Container = styled.div`
  background-size: cover;
  display: flex;
  align-items: center;
  position: relative;
  max-width: 320px;
`;

export const Image = styled.img`
  max-width: 100%;
  cursor: pointer;
  z-index: 10;
  height: 200px;
  width: 450px;
  border-radius: 8px;
`;

export const ButtonContainer = styled.div`
  width: 22.3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  position: absolute;
  z-index: 20;

  @media (max-width: 1100px) {
    width: 16.1rem;
  }
`;

export const Background = styled.div`
  z-index: 9999;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ImageExpanded = styled.img`
  height: 90%;
  cursor: pointer;
  position: absolute;
  z-index: 2;
  overflow-y: hidden;
`;

export const ButtonContainerExpanded = styled.div`
  width: 58rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  position: absolute;
  z-index: 20;
`;
